"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockMenuType = void 0;
/* tslint:disable:no-duplicate-string max-line-length */

var mockMenuType = {
  itemType: 'LTO',
  menuItems: [{
    calories: 2130,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: 'Pizza',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 201100,
    itemCaloriesText: '2130 Cal',
    itemDescription: 'Large thin crust pizza topped right to the edge with Pepperoni and Cheese.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Pepperoni (2130 Cal)',
    itemName: 'Thin Crust Pepperoni',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'EMB-TPEP',
    menuWarnings: null,
    orderable: true,
    price: 7.49,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 1980,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: 'Pizza',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 201108,
    itemCaloriesText: '1980 Cal',
    itemDescription: 'Large thin crust pizza topped right to the edge with Cheese.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Cheese (1980 Cal)',
    itemName: 'Thin Crust Cheese',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'HNR-THINCHS',
    menuWarnings: null,
    orderable: true,
    price: 7.49,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 3810,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: '',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f531c530-5fa5-478f-9d88-c458a6002803.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/f531c530-5fa5-478f-9d88-c458a6002803.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 601111,
    itemCaloriesText: '3810 Cal',
    itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter PEPSI®.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Meal Deal with Pepsi® (3810 Cal)',
    itemName: 'Thin Crust Meal Deal with Pepsi®',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'EMB-COMBOTCPEP',
    menuWarnings: null,
    orderable: true,
    price: 11.99,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 2960,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: '',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9d142344-d787-4948-84b4-851c37b53624.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/9d142344-d787-4948-84b4-851c37b53624.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 601111,
    itemCaloriesText: '2960 Cal',
    itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Diet PEPSI®.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Meal Deal with Diet Pepsi® (2960 Cal)',
    itemName: 'Thin Crust Meal Deal with Diet Pepsi®',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'EMB-COMBOTCDPEP',
    menuWarnings: null,
    orderable: true,
    price: 11.99,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 3920,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: '',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/81629afe-20a7-443b-8120-6c59ca35b38c.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/81629afe-20a7-443b-8120-6c59ca35b38c.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 601111,
    itemCaloriesText: '3920 Cal',
    itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Mountain Dew®.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Meal Deal with Mountain Dew® (3920 Cal)',
    itemName: 'Thin Crust Meal Deal with Mountain Dew®',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'EMB-COMBOTCMDEW',
    menuWarnings: null,
    orderable: true,
    price: 11.99,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 3750,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: '',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/305fdee2-343f-4f46-8adf-d34e5b8d7b06.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/305fdee2-343f-4f46-8adf-d34e5b8d7b06.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 601111,
    itemCaloriesText: '3750 Cal',
    itemDescription: 'Thin Crust Pepperoni pizza, Crazy Combo® and a 2-liter Sierra Mist®.',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Thin Crust Meal Deal with Sierra Mist® (3750 Cal)',
    itemName: 'Thin Crust Meal Deal with Sierra Mist®',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'EMB-COMBOTCMT',
    menuWarnings: null,
    orderable: true,
    price: 11.99,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 800,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: 'Side',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/cc2e2c53-ee15-430c-b90a-b04820316319.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 101289,
    itemCaloriesText: '800 Cal',
    itemDescription: 'Brownie topped with Cookie Dough Frosting and TWIX® Cookie Bar Pieces | 4-piece order',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces (800 Cal)',
    itemName: 'Cookie Dough Brownie made with TWIX® Cookie Bar Pieces',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'HNRS-KDBTWX',
    menuWarnings: null,
    orderable: true,
    price: 3.89,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }, {
    calories: 840,
    caloriesRange: '',
    comment: '',
    crustImages: null,
    favoriteId: 0,
    favoriteName: null,
    foodGroup: 'Side',
    id: 0,
    images: [{
      imageAltText: '',
      imageType: 'Web_ItemDetailImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
    }, {
      imageAltText: '',
      imageType: 'Web_MenuImage',
      imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e7741f5f-e5e1-4b59-a395-c6e6714c1a44.jpg'
    }],
    isCustomMenuItem: false,
    itemId: 101288,
    itemCaloriesText: '840 Cal',
    itemDescription: 'Brownie topped with Cookie Dough Frosting and M&M’S® MINIS Chocolate Candies | 4-piece order',
    itemDescriptionWithCalories: null,
    itemNameWithCalories: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies (840 Cal)',
    itemName: 'Cookie Dough Brownie made with M&M’S® MINIS Chocolate Candies',
    itemType: 'LTO',
    maxToppings: 0,
    menuItemCode: 'HNRS-CDBMM',
    menuWarnings: null,
    orderable: true,
    price: 3.89,
    selectedCustomOptions: null,
    selectedToppings: null,
    toppingsThresholdCount: 0,
    toppingsThresholdMessage: null,
    servings: ''
  }],
  typeDescription: 'Limited Time Offer'
};
exports.mockMenuType = mockMenuType;